<div class="section" id="home">
  <div class="container">
    <Heading />

    <div class="columns">
      <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
        {#if videoUrlManager}
          <h2 class="is-size-5 mb-3 has-text-centered">
            Dein Clubmanager stellt sich vor:
          </h2>
          <Videoplayer videoUrl="{videoUrlManager}" />
        {/if}
      </div>
    </div>

    <div class="columns">
      <div class="column is-one-fifth"></div>
      <div class="column is-two-fifth-fifth">
        Beginne jetzt mit dem theoretischen Teil deiner Platzreife-Prüfung
      </div>
      <div class="column is-two-fifth-fifth has-text-right">
        <button
          class="button is-outlined"
          on:click="{() => push('/home')}"
        >Starten</button>
      </div>
      <div class="column is-one-fifth"></div>
    </div>
  </div>
</div>

<script>
import { push } from "svelte-spa-router";
import Heading from "./Heading.svelte";
import { club, userProgress } from "./stores";
import Videoplayer from "./Videoplayer.svelte";
let videoUrlManager,
  up = {};

club.subscribe((data) => {
  videoUrlManager = data.manager.video;
});

userProgress.subscribe((value) => {
  up = value;
});

// const hideAndContinue = () => {
//   up.skipManager = true;
//   progressSvc.setUserProgress(up);
//   push('/home');
// }
</script>

<style type="text/scss">
// @import "./scss/video-iframe";
.is-max-width-90 {
  max-width: 90%;
}
.tile-image-button {
  cursor: pointer;
  height: 60vh;
  background-size: cover;
  background-position: center center;
  .title {
    color: #fff;
    text-shadow: 1px 1px 2px #000;
  }
}
</style>
